import { render, staticRenderFns } from "./centerMemberWorks.vue?vue&type=template&id=6d16078b&scoped=true&"
import script from "./centerMemberWorks.vue?vue&type=script&lang=js&"
export * from "./centerMemberWorks.vue?vue&type=script&lang=js&"
import style0 from "./centerMemberWorks.vue?vue&type=style&index=0&id=6d16078b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d16078b",
  null
  
)

export default component.exports